import { render, staticRenderFns } from "./PersonalInfoForm.vue?vue&type=template&id=46787770&scoped=true&"
import script from "./PersonalInfoForm.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfoForm.vue?vue&type=style&index=0&id=46787770&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46787770",
  null
  
)

export default component.exports